export const ar = {
  // Navigation
  home: "الرئيسية",
  about: "من نحن",
  tours: "الجولات",
  deals: "العروض",
  testimonials: "الشهادات",
  blog: "المدونة",
  contact: "اتصل بنا",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "مرحباً بكم في سريلانكا",
  welcomeSubtitle: "اكتشفوا جمال لؤلؤة المحيط الهندي",
  exploreButton: "استكشف الجولات",
  learnMoreButton: "اعرف المزيد",
  
  // About page
  aboutTitle: "من نحن",
  aboutSubtitle: "شريككم الموثوق في السفر في سريلانكا",
  aboutDescription: "نحن متخصصون في إنشاء تجارب سفر لا تُنسى عبر سريلانكا، من الشواطئ البكر إلى المعابد القديمة.",
  
  // Tours page
  toursTitle: "جولاتنا",
  toursSubtitle: "اكتشفوا وجهات مذهلة",
  bookNow: "احجز الآن",
  viewDetails: "عرض التفاصيل",
  
  // Contact page
  contactTitle: "اتصل بنا",
  contactSubtitle: "تواصلوا معنا",
  name: "الاسم",
  email: "البريد الإلكتروني",
  message: "الرسالة",
  send: "إرسال الرسالة",
  phone: "الهاتف",
  address: "العنوان",
  
  // Testimonials
  testimonialsTitle: "ماذا يقول عملاؤنا",
  testimonialsSubtitle: "تجارب حقيقية من مسافرين حقيقيين",
  
  // Blog
  blogTitle: "مدونة السفر",
  blogSubtitle: "أحدث قصص السفر والنصائح",
  readMore: "اقرأ المزيد",
  
  // Common
  loading: "جاري التحميل...",
  error: "حدث خطأ",
  success: "نجح!",
  close: "إغلاق",
  submit: "إرسال",
  cancel: "إلغاء",
  
  // Language selector
  selectLanguage: "اختر اللغة",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  russian: "Русский",
  chinese: "中文",
  hindi: "हिन्दी",
  arabic: "العربية",
  
  // About Us Page
  whyChooseTitle: "لماذا تختارون سري ياترا للسفر؟",
  whyChooseSubtitle: "نحن ملتزمون بتقديم أفضل تجارب السفر مع خدمة استثنائية وحزم مخصصة.",
  personalizedTitle: "تخطيط السفر المخصص",
  personalizedDesc: "نحن نخصص كل رحلة لتلبية احتياجاتكم الفريدة، مما يضمن تجربة سفر فريدة من نوعها.",
  customerSupportTitle: "دعم العملاء على مدار الساعة",
  customerSupportDesc: "خبراؤنا المتفانون في السفر متاحون على مدار الساعة لمساعدتكم في أي استفسار.",
  destinationsTitle: "الوجهات المختارة بعناية",
  destinationsDesc: "استكشفوا أفضل الوجهات المختارة بعناية لتقديم تجارب لا تُنسى لكم.",
  priceGuaranteeTitle: "ضمان أفضل سعر",
  priceGuaranteeDesc: "نحن نقدم أسعاراً تنافسية دون المساس بجودة تجربة السفر الخاصة بكم.",
  luxuryTitle: "الفخامة والراحة",
  luxuryDesc: "استمتعوا بإقامة فاخرة وترتيبات سفر سلسة للحصول على أقصى راحة.",
  guidesTitle: "مرشدو الجولات الخبراء",
  guidesDesc: "مرشدونا المطلعون والودودون يضمنون لكم الاستفادة القصوى من رحلتكم.",
  
  // Contact Page
  getInTouchTitle: "تواصلوا مع سري ياترا للسفر",
  loveToHearTitle: "نحب أن نسمع منكم",
  loveToHearDesc: "سواء كان لديكم سؤال حول جولاتنا أو الأسعار أو أي شيء آخر، فريقنا مستعد للإجابة على جميع أسئلتكم.",
  office: "المكتب",
  phone: "الهاتف",
  support: "الدعم",
  email: "البريد الإلكتروني",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "أرسلوا لنا رسالة",
  contactFormDesc: "املأوا النموذج أدناه وسنرد عليكم في أقرب وقت ممكن.",
  namePlaceholder: "اسمكم",
  emailPlaceholder: "بريدكم الإلكتروني",
  phonePlaceholder: "رقم هاتفكم",
  messagePlaceholder: "رسالتكم",
  submitButton: "إرسال الرسالة",
  submitting: "جاري الإرسال...",
  messageSent: "تم إرسال الرسالة بنجاح!",
  messageError: "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.",
  
  // Testimonials Page
  customerReviewsTitle: "ماذا يقول عملاؤنا",
  customerReviewsSubtitle: "تجارب حقيقية من مسافرين حقيقيين استكشفوا سريلانكا معنا",
  
  // Blog Page
  travelBlogTitle: "مدونة السفر",
  travelBlogSubtitle: "أحدث قصص السفر والنصائح والرؤى من مغامراتنا في سريلانكا",
  
  // Tours Page
  ourToursTitle: "جولاتنا",
  ourToursSubtitle: "اكتشفوا وجهات مذهلة وتجارب لا تُنسى",
  
  // Deals Page
  specialDealsTitle: "العروض الخاصة",
  specialDealsSubtitle: "عروض حصرية وخصومات على أفضل جولاتنا",
  
  // Tour Content
  culturalTourTitle: "جولة ثقافية في سريلانكا",
  culturalTourDesc: "اختبروا التراث الغني والمواقع التاريخية في سريلانكا في هذه الجولة الثقافية.",
  wildlifeTourTitle: "مغامرة سفاري الحياة البرية",
  wildlifeTourDesc: "استكشفوا حدائق الحياة البرية الشهيرة في سريلانكا وشاهدوا الحيوانات الغريبة في موطنها الطبيعي.",
  beachTourTitle: "عطلة شاطئية",
  beachTourDesc: "استرخوا على أجمل شواطئ سريلانكا مع المياه البلورية والرمال الذهبية.",
  hillCountryTourTitle: "مغامرة البلد الجبلي",
  hillCountryTourDesc: "اكتشفوا الجمال الخلاب لجبال سريلانكا وشلالاتها ومزارع الشاي.",
  honeymoonTourTitle: "حزمة شهر العسل الفاخرة",
  honeymoonTourDesc: "استمتعوا بتجربة شهر عسل رومانسية وفاخرة في أفضل منتجعات سريلانكا.",
  adventureTourTitle: "جولة المغامرة والمشي لمسافات طويلة",
  adventureTourDesc: "انطلقوا في مغامرات المشي لمسافات طويلة المثيرة والأنشطة الخارجية في سريلانكا.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "حزمة شهر العسل الحصرية في سريلانكا",
  exclusiveHoneymoonDesc: "استمتعوا بشهر عسل فاخر مع رحلات رومانسية ومنتجعات شاطئية وتجارب ثقافية.",
  adventureWildlifeTitle: "جولة المغامرة والحياة البرية",
  adventureWildlifeDesc: "استكشفوا البرية في سريلانكا مع سفاري مثيرة ورحلات استكشافية طبيعية.",
  luxuryBeachTitle: "عطلة شاطئية فاخرة",
  luxuryBeachDesc: "استرخوا على أفضل الشواطئ واستمتعوا بالرياضات المائية واختبروا الضيافة من الدرجة الأولى.",
  culturalHeritageTitle: "جولة التراث الثقافي",
  culturalHeritageDesc: "زوروا مواقع التراث العالمي لليونسكو والمعابد القديمة والمدن النابضة بالحياة في سريلانكا.",
  budgetFamilyTitle: "عطلة عائلية اقتصادية",
  budgetFamilyDesc: "حزمة عائلية ميسورة التكلفة مع أنشطة مثيرة لجميع الأعمار.",
  ultimateAdventureTitle: "جولة المغامرة النهائية",
  ultimateAdventureDesc: "المشي لمسافات طويلة والتجديف والرياضات المغامرة في المناظر الطبيعية المذهلة في سريلانكا.",
  
  // Blog Content
  exploringBeautyTitle: "استكشاف جمال سريلانكا",
  exploringBeautyExcerpt: "اكتشفوا المناظر الطبيعية الخلابة والتاريخ الغني وعجائب الثقافة في سريلانكا في هذا الدليل الشامل للسفر.",
  bestBeachesTitle: "أفضل شواطئ سريلانكا",
  bestBeachesExcerpt: "من الشواطئ الرملية الذهبية إلى المياه الفيروزية المذهلة، استكشفوا أفضل الوجهات الشاطئية في سريلانكا للحصول على رحلة مثالية.",
  wildlifeSafariTitle: "مغامرات سفاري الحياة البرية",
  wildlifeSafariExcerpt: "اختبروا الإثارة في رؤية الفيلة والنمور والطيور الغريبة في حدائق سريلانكا الوطنية الشهيرة.",
  
  // Testimonial Content
  johnReview: "رحلتنا إلى سريلانكا كانت رائعة تماماً! كانت التخطيط والتنظيم مثاليين، وشعرنا بالرعاية الجيدة طوال الرحلة. نوصي بشدة بشركة سري ياترا للسفر!",
  emmaReview: "تجربة لا تُنسى حقاً! من الشواطئ الجميلة إلى المواقع الثقافية المذهلة، كل شيء كان مخططاً بشكل مثالي. لا أستطيع الانتظار للعودة!",
  carlosReview: "أفضل وكالة سفر حجزت معها على الإطلاق! كان كل شيء منظم بشكل جيد، والمرشدون كانوا مطلعين وودودين. شكراً لكم على التجربة المذهلة!",
  sophiaReview: "رحلة سلسة ولا تُنسى! كان الفريق مهنياً، والجدول الزمني مدروس بشكل جيد. أنصح بشدة بشركة سري ياترا للسفر لأي شخص يزور سريلانكا.",
  
  // Common Labels
  activities: "الأنشطة",
  duration: "المدة",
  price: "السعر",
  workingHours: "ساعات العمل",
  workingHoursText: "الاثنين – الجمعة: 9:00 صباحاً – 6:00 مساءً",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "أبرز معالم سريلانكا",
  fiveDayHighlightsSubtitle: "الأبرز: كاتوناييك، سيجيريا، كاندي، إيلا، جالي. رحلة مدمجة عبر وجهات سريلانكا التي يجب زيارتها.",
  bookNow: "احجز الآن",
  
  // Katunayake
  day1Title: "الوصول",
  katunayakeTitle: "كاتوناييك",
  katunayakeStay: "إقامة مريحة بالقرب من كاتوناييك",
  katunayakeActivities: "الأنشطة",
  katunayakeArrival: "الوصول إلى مطار باندارانايكي الدولي",
  katunayakeMeetGreet: "اللقاء والترحيب، النقل إلى الإقامة القريبة",
  katunayakeNegombo: "زيارة اختيارية لشاطئ نيغومبو (إذا سمح الوقت)",
  katunayakeRest: "الراحة والاستشفاء من الرحلة",
  katunayakeLocation: "كاتوناييك - مطار باندارانايكي الدولي",
  katunayakeDescription: "ابدأوا أبرز معالم سريلانكا مع أول ليلة مريحة بالقرب من المطار.",
  
  // Sigiriya
  day2Title: "سيجيريا",
  sigiriyaTitle: "سيجيريا",
  sigiriyaStay: "بيت ضيافة في سيجيريا",
  sigiriyaTransfer: "النقل إلى سيجيريا",
  sigiriyaClimb: "تسلق قلعة سيجيريا الصخرية",
  sigiriyaExplore: "استكشاف الحدائق المائية والجداريات",
  sigiriyaVillage: "تجربة القرية أو ركوب الدراجة (اختياري)",
  sigiriyaLocation: "قلعة سيجيريا الصخرية",
  sigiriyaDescription: "موقع تراث عالمي لليونسكو مع إطلالات واسعة.",
  
  // Kandy
  day3Title: "كاندي",
  kandyTitle: "كاندي",
  kandyStay: "فندق في كاندي",
  kandyTransfer: "النقل إلى كاندي",
  kandyTemple: "معبد السن المقدس",
  kandyGardens: "الحدائق النباتية الملكية، بيرادينيا",
  kandyLake: "نزهة حول بحيرة كاندي والسوق المحلي",
  kandyLocation: "معبد السن المقدس، كاندي",
  kandyDescription: "العاصمة الثقافية مع التراث المقدس والحدائق الخضراء.",
  
  // Ella
  day4Title: "إيلا",
  ellaTitle: "إيلا",
  ellaStay: "إقامة مريحة في إيلا",
  ellaTrain: "رحلة قطار خلابة إلى إيلا",
  ellaPeak: "مشي إلى قمة آدم الصغيرة",
  ellaBridge: "نقطة مراقبة جسر الأقواس التسعة",
  ellaExplore: "استكشاف أجواء بلد الشاي في المدينة",
  ellaLocation: "قطار خلابة بالقرب من إيلا",
  ellaDescription: "ملاذ جبلي بمناخ بارد مع مناظر جبلية خلابة.",
  
  // Galle
  day5Title: "جالي",
  galleTitle: "جالي",
  galleStay: "فندق في جالي (أو مغادرة متأخرة)",
  galleTransfer: "النقل إلى جالي",
  galleFort: "استكشاف قلعة جالي المدرجة في قائمة اليونسكو",
  galleLighthouse: "نزهة في المنارة وأسوار القلعة",
  galleCafes: "المقاهي والمتاجر وإطلالات البحر",
  galleContinue: "المتابعة إلى المطار أو تمديد الإقامة الشاطئية",
  galleLocation: "أسوار قلعة جالي والمنارة",
  galleDescription: "سحر ساحلي تاريخي لإنهاء أبرز معالمكم",
  
  // Colombo Tour
  threeDayColomboTitle: "رحلة كولومبو - سريلانكا",
  threeDayColomboSubtitle: "اختبروا أفضل ما في كولومبو مع الفنادق الفاخرة والزيارات الثقافية والتسوق والاسترخاء على المحيط.",
  
  // Colombo
  dayOneTitle: "الوصول",
  dayTwoTitle: "جولة المدينة", 
  dayThreeTitle: "المغادرة",
  
  // Day One Activities
  colomboArrival: "الوصول إلى مطار باندارانايكي الدولي",
  colomboTransfer: "النقل إلى الفندق وتسجيل الوصول",
  colomboFort: "استكشاف منطقة قلعة كولومبو – المباني الاستعمارية والأسواق والتسوق",
  colomboDinner: "العشاء في مطعم الفندق والإقامة ليلاً.",
  
  // Day Two Activities
  colomboBreakfast: "الإفطار في الفندق",
  colomboTemple: "زيارة معبد جانجارامايا والمتحف",
  colomboLunch: "الغداء في مطعم محلي",
  colomboMuseum: "زيارة بعد الظهر للمتحف الوطني وحديقة فيهاراماهاديفي",
  colomboOvernight: "العشاء والإقامة ليلاً.",
  
  // Day Three Activities
  colomboRelax: "الاسترخاء في جال فيس جرين ومشاهدة المحيط",
  colomboShopping: "التسوق في أوديل أو معرض بيرفوت",
  colomboPrepare: "التحضير للمغادرة",
  colomboCheckout: "تسجيل الخروج والنقل إلى المطار.",
  
  // Hotels
  cinnamonGrand: "سينامون جراند كولومبو",
  shangriLa: "شانغريلا كولومبو",
  kingsbury: "ذا كينغزبري كولومبو",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "حزمة الميزانية (أبرز معالم سريلانكا)",
  fiveDayBudgetPackSubtitle: "الأبرز",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "ميزانية",
  fiveDayBudgetPackHighlights: "الأبرز",
  fiveDayBudgetPackCulture: "الثقافة",
  fiveDayBudgetPackHistory: "التاريخ",
  fiveDayBudgetPackNature: "الطبيعة",
  fiveDayBudgetPackPrice: "من US $650 للشخص",
  moreInformation: "مزيد من المعلومات ➜",
  
  threeDayColomboCityTitle: "تجربة مدينة كولومبو",
  threeDayColomboCitySubtitle: "جولة المدينة",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "جولة المدينة",
  threeDayColomboCityCulture: "الثقافة",
  threeDayColomboCityShopping: "التسوق",
  threeDayColomboCityLuxury: "الفنادق الفاخرة",
  threeDayColomboCitySightseeing: "المعالم السياحية",
  threeDayColomboCityPrice: "من US $350 للشخص",
  
  familyTripTitle: "رحلة عائلية إلى سريلانكا",
  familyTripSubtitle: "حزمة عائلية",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "الحياة البرية",
  familyTripNature: "الطبيعة",
  familyTripCulture: "الثقافة",
  familyTripHistory: "التاريخ",
  familyTripPrice: "من US $850 للشخص",
  
  bestOfSriLankaTitle: "أفضل ما في سريلانكا",
  bestOfSriLankaSubtitle: "شامل",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "الشاطئ",
  bestOfSriLankaWildlife: "الحياة البرية",
  bestOfSriLankaNature: "الطبيعة",
  bestOfSriLankaCulture: "الثقافة",
  bestOfSriLankaPrice: "من US $1250 للشخص",
  
  romanticGetawayTitle: "رحلة رومانسية في سريلانكا",
  romanticGetawaySubtitle: "حزمة رومانسية",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "الطبيعة",
  romanticGetawayBeach: "الشاطئ",
  romanticGetawayWildlife: "الحياة البرية",
  romanticGetawayHistory: "التاريخ",
  romanticGetawayPrice: "من US $1700 للشخص",
  
  // Why Choose Us
  whyChooseUsTitle: "لماذا تختاروننا",
  whyChooseUsSubtitle: "اختارنا العديد من الأشخاص كشركتهم رقم واحد في إدارة الوجهات السياحية، وستختاروننا أيضاً للأسباب التالية.",
  
  whyChooseUsReason1: "نحن من الشركات الرائدة في إدارة الوجهات في سريلانكا.",
  whyChooseUsReason2: "نحن من مشغلي الجولات الرائدين في سريلانكا.",
  whyChooseUsReason3: "نحن نقدم حزمة سفر كاملة للمسافرين ووكلاء السفر.",
  whyChooseUsReason4: "لدينا فريق متحمس ومهني من 40 ممثلاً مع معرفة واسعة بسياحة سريلانكا.",
  whyChooseUsReason5: "نحن من وكلاء السفر الرائدين في سريلانكا.",
  whyChooseUsReason6: "نحن نقدم جولات مخصصة ومتخصصة لعملائنا.",
  whyChooseUsReason7: "نحن وكيل سفر رائد في سريلانكا يقدم جولات وحزم عطلات للوجهات الغريبة.",
  whyChooseUsReason8: "نحن نقدم دعم العملاء على مدار الساعة لعملائنا.",
  
  readMore: "اقرأ المزيد",
  
  // How It Works
  howItWorksTitle: "كيف يعمل؟",
  
  // Common UI elements
  days: "الأيام",
  from: "من",
  perPerson: "للشخص",
  
  step1Title: "1. استفسر الآن",
  step1Time: "5 دقائق",
  step1FillingForm: "ملء النموذج الإلكتروني",
  step1WebChat: "محادثة ويب مباشرة",
  step1Email: "البريد الإلكتروني",
  step1Call: "اتصل بنا",
  
  step2Title: "2. تواصل مع خبير السفر",
  step2Time: "30 دقيقة",
  step2Discuss: "ناقش متطلباتك",
  step2FreeAdvice: "نصائح سفر مجانية من الخبراء",
  step2Support: "دعم على مدار الساعة",
  
  step3Title: "3. احصل على 3 خيارات سفر",
  step3Discuss: "ناقش التغييرات",
  step3Finalise: "أكمل خطة السفر",
  step3Pay: "ادفع 10%",
  
  step4Title: "4. احصل على تأكيد رحلتك",
  step4FillingForm: "ملء النموذج الإلكتروني",
  step4Satisfaction: "ضمان الرضا 100%",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "دائرة سريلانكا الكاملة",
  completeSriLankaSubtitle: "شامل",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "شامل",
  completeSriLankaHighlights: "الأبرز",
  completeSriLankaCulture: "الثقافة",
  completeSriLankaHistory: "التاريخ",
  completeSriLankaNature: "الطبيعة",
  completeSriLankaBeach: "الشاطئ",
  completeSriLankaPrice: "من US $1850 للشخص",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "دائرة سريلانكا الكاملة",
  completeSriLankaCircuitSubtitle: "اختبروا الجمال الكامل لسريلانكا مع هذه الرحلة الشاملة التي تغطي جميع الوجهات الرئيسية.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "أنورادابورا",
  ancientCityStay: "فندق في أنورادابورا",
  ancientCityTransfer: "النقل إلى أنورادابورا",
  ancientCityExplore: "استكشاف الآثار القديمة والأستوبا",
  ancientCityTemple: "زيارة شجرة سري مها بودي",
  ancientCityMuseum: "زيارة المتحف الأثري",
  ancientCityLocation: "مدينة أنورادابورا القديمة",
  ancientCityDescription: "اكتشفوا العاصمة القديمة لسريلانكا وموقع التراث العالمي لليونسكو.",
  
  // Nuwara Eliya
  day5Title: "نوارا إيليا",
  nuwaraEliyaTitle: "نوارا إيليا",
  nuwaraEliyaStay: "فندق في نوارا إيليا",
  nuwaraEliyaTransfer: "النقل إلى نوارا إيليا",
  nuwaraEliyaTea: "جولة مزارع الشاي والمصنع",
  nuwaraEliyaLake: "ركوب قارب في بحيرة غريغوري",
  nuwaraEliyaExplore: "استكشاف إنجلترا الصغيرة",
  nuwaraEliyaLocation: "بلد الشاي في نوارا إيليا",
  nuwaraEliyaDescription: "اختبروا المناخ البارد وسحر بلد الشاي في إنجلترا الصغيرة.",
  
  // Ella (Second Day)
  day6Title: "إيلا",
  day7Title: "إيلا الممتدة",
  ellaWaterfall: "زيارة شلالات رافانا",
  ellaTea: "جولة مزارع الشاي",
  ellaRelax: "الاسترخاء والاستمتاع بمناظر الجبال",
  ellaLocal: "تجربة القرية المحلية",
  ellaDay2Description: "اليوم الثاني في إيلا لاستكشاف الشلالات وبلد الشاي.",
  
  // Mirissa
  day8Title: "ميريسا",
  mirissaTitle: "ميريسا",
  mirissaStay: "منتجع شاطئي في ميريسا",
  mirissaTransfer: "النقل إلى ميريسا",
  mirissaBeach: "الاسترخاء على شاطئ ميريسا",
  mirissaWhale: "جولة مشاهدة الحيتان (موسمية)",
  mirissaRelax: "الاسترخاء على الشاطئ وغروب الشمس",
  mirissaLocation: "شاطئ ميريسا",
  mirissaDescription: "استمتعوا بالشواطئ الجميلة وفرص مشاهدة الحيتان.",
  
  // Mirissa (Second Day)
  day9Title: "ميريسا الممتدة",
  mirissaSnorkel: "الغوص والرياضات المائية",
  mirissaDiving: "الغوص العميق (اختياري)",
  mirissaSunset: "نزهة شاطئية عند غروب الشمس",
  mirissaDay2Description: "اليوم الثاني في ميريسا للأنشطة المائية والاسترخاء على الشاطئ.",
  
  // Galle
  day10Title: "جالي",
  
  // Galle (Second Day)
  day11Title: "جالي الممتدة",
  galleShopping: "التسوق في قلعة جالي",
  galleMuseum: "زيارة متحف جالي البحري",
  galleBeach: "وقت الشاطئ في أوناواتونا",
  galleDining: "العشاء في مطاعم القلعة",
  galleDay2Description: "اليوم الثاني في جالي لاستكشاف المزيد من القلعة التاريخية.",
  
  // Bentota
  day12Title: "بينتوتا",
  bentotaTitle: "بينتوتا",
  bentotaStay: "منتجع في بينتوتا",
  bentotaTransfer: "النقل إلى بينتوتا",
  bentotaRiver: "سفاري نهر بينتوتا",
  bentotaBeach: "أنشطة الشاطئ",
  bentotaSpa: "العلاجات الصحية والسبا",
  bentotaLocation: "منتجع شاطئ بينتوتا",
  bentotaDescription: "استرخوا في المنتجع الشاطئي الجميل مع أنشطة النهر.",
  
  // Colombo
  day13Title: "كولومبو",
  colomboTitle: "كولومبو",
  colomboStay: "فندق في كولومبو",
  colomboTransfer: "النقل إلى كولومبو",
  colomboFort: "استكشاف قلعة كولومبو",
  colomboTemple: "زيارة معبد جانجارامايا",
  colomboShopping: "التسوق في أوديل وبيرفوت",
  colomboLocation: "مدينة كولومبو",
  colomboDescription: "استكشفوا معالم العاصمة والتسوق.",
  
  // Departure
  day14Title: "المغادرة",
  departureTitle: "المغادرة",
  departureStay: "فندق المطار أو المغادرة",
  departureBreakfast: "الإفطار الأخير",
  departureShopping: "التسوق في اللحظة الأخيرة",
  departureTransfer: "النقل إلى المطار",
  departureAirport: "المغادرة من مطار باندارانايكي الدولي",
  departureLocation: "مطار باندارانايكي الدولي",
  departureDescription: "اليوم الأخير مع النقل إلى المطار والمغادرة.",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "جولة الحياة البرية والتراث الثقافي",
  wildlifeCulturalCircuitSubtitle: "اختبر الحياة البرية والمدن القديمة والتراث الثقافي لسريلانكا في هذه الرحلة الشاملة.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "أوداوالاوا",
  udawalaweStay: "نزل سفاري في أوداوالاوا",
  udawalaweTransfer: "النقل إلى أوداوالاوا",
  udawalaweSafari: "سفاري في حديقة أوداوالاوا الوطنية",
  udawalaweElephants: "مراقبة الأفيال والتصوير",
  udawalaweBirds: "جولة مراقبة الطيور",
  udawalaweLocation: "حديقة أوداوالاوا الوطنية",
  udawalaweDescription: "اختبر الحياة البرية في سريلانكا مع الأفيال والطيور والحيوانات الأخرى في موطنها الطبيعي.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "إيلا",
  ellaWildlifeStay: "فندق في إيلا",
  ellaWildlifeTransfer: "النقل إلى إيلا",
  ellaWildlifeTrain: "رحلة قطار خلابة إلى إيلا",
  ellaWildlifePeak: "نزهة إلى قمة آدم الصغيرة",
  ellaWildlifeBridge: "نقطة مراقبة جسر الأقواس التسعة",
  ellaWildlifeLocation: "محطة إيلا الجبلية",
  ellaWildlifeDescription: "استكشف البلد الجبلي الجميل مع مناظر جبلية خلابة ومزارع الشاي.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "نوارا إيليا",
  nuwaraEliyaWildlifeStay: "فندق في نوارا إيليا",
  nuwaraEliyaWildlifeTransfer: "النقل إلى نوارا إيليا",
  nuwaraEliyaWildlifeTea: "جولة في مزرعة الشاي والمصنع",
  nuwaraEliyaWildlifeLake: "رحلة قارب في بحيرة غريغوري",
  nuwaraEliyaWildlifeExplore: "استكشف إنجلترا الصغيرة",
  nuwaraEliyaWildlifeLocation: "بلد الشاي نوارا إيليا",
  nuwaraEliyaWildlifeDescription: "اختبر المناخ البارد وسحر بلد الشاي في إنجلترا الصغيرة.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "كاندي",
  kandyWildlifeStay: "فندق في كاندي",
  kandyWildlifeTransfer: "النقل إلى كاندي",
  kandyWildlifeTemple: "معبد الأسنان المقدسة",
  kandyWildlifeGardens: "الحدائق النباتية الملكية",
  kandyWildlifeLake: "نزهة حول بحيرة كاندي",
  kandyWildlifeLocation: "معبد الأسنان المقدسة",
  kandyWildlifeDescription: "العاصمة الثقافية مع التراث المقدس والحدائق الخصبة.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "سيجيريا",
  sigiriyaWildlifeStay: "فندق في سيجيريا",
  sigiriyaWildlifeTransfer: "النقل إلى سيجيريا",
  sigiriyaWildlifeClimb: "تسلق قلعة صخرة سيجيريا",
  sigiriyaWildlifeExplore: "استكشاف الحدائق المائية والجداريات",
  sigiriyaWildlifeVillage: "تجربة القرية أو رحلة دراجة (اختياري)",
  sigiriyaWildlifeLocation: "قلعة صخرة سيجيريا",
  sigiriyaWildlifeDescription: "موقع تراث عالمي أيقوني لليونسكو مع إطلالات بانورامية.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "أنورادابورا",
  anuradhapuraWildlifeStay: "فندق في أنورادابورا",
  anuradhapuraWildlifeTransfer: "النقل إلى أنورادابورا",
  anuradhapuraWildlifeExplore: "استكشاف الآثار القديمة والأستوبا",
  anuradhapuraWildlifeTemple: "زيارة شجرة سري ماها بودي",
  anuradhapuraWildlifeMuseum: "زيارة المتحف الأثري",
  anuradhapuraWildlifeLocation: "المدينة القديمة أنورادابورا",
  anuradhapuraWildlifeDescription: "اكتشف العاصمة القديمة لسريلانكا وموقع التراث العالمي لليونسكو.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "بولوناروا",
  polonnaruwaStay: "فندق في بولوناروا",
  polonnaruwaTransfer: "النقل إلى بولوناروا",
  polonnaruwaExplore: "استكشاف الآثار القديمة",
  polonnaruwaGalVihara: "زيارة غال فيهارا",
  polonnaruwaMuseum: "زيارة متحف بولوناروا",
  polonnaruwaLocation: "المدينة القديمة بولوناروا",
  polonnaruwaDescription: "استكشف العاصمة القديمة مع الآثار والمنحوتات المحفوظة جيداً.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "ترينكومالي",
  trincomaleeStay: "فندق في ترينكومالي",
  trincomaleeTransfer: "النقل إلى ترينكومالي",
  trincomaleeBeach: "الاسترخاء على شاطئ نيلافيلي",
  trincomaleeWhale: "جولة مراقبة الحيتان (موسمية)",
  trincomaleeFort: "استكشاف حصن فريدريك",
  trincomaleeLocation: "شاطئ نيلافيلي، ترينكومالي",
  trincomaleeDescription: "استمتع بالشواطئ الجميلة وفرص مراقبة الحيتان.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "كولومبو",
  colomboWildlifeStay: "فندق في كولومبو",
  colomboWildlifeTransfer: "النقل إلى كولومبو",
  colomboWildlifeFort: "استكشاف حصن كولومبو",
  colomboWildlifeTemple: "زيارة معبد جانجارامايا",
  colomboWildlifeShopping: "التسوق في أوديل وبيرافوت جاليري",
  colomboWildlifeLocation: "مدينة كولومبو",
  colomboWildlifeDescription: "استكشف معالم العاصمة والتسوق.",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "جولة الحياة البرية والتراث الثقافي",
  wildlifeCulturalType: "الحياة البرية والثقافة",
  wildlifeCulturalHighlights: "المعالم البارزة",
  wildlifeCulturalWildlife: "الحياة البرية",
  wildlifeCulturalCulture: "الثقافة",
  wildlifeCulturalHistory: "التاريخ",
  wildlifeCulturalNature: "الطبيعة",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "جولة البلد الجبلي والشواطئ",
  hillCountryBeachType: "البلد الجبلي والشواطئ",
  hillCountryBeachHighlights: "المعالم البارزة",
  hillCountryBeachNature: "الطبيعة",
  hillCountryBeachBeach: "الشاطئ",
  hillCountryBeachCulture: "الثقافة",
  hillCountryBeachAdventure: "المغامرة",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "جولة المثلث الثقافي والشواطئ",
  culturalTriangleBeachType: "المثلث الثقافي والشواطئ",
  culturalTriangleBeachHighlights: "المعالم البارزة",
  culturalTriangleBeachCulture: "الثقافة",
  culturalTriangleBeachHistory: "التاريخ",
  culturalTriangleBeachBeach: "الشاطئ",
  culturalTriangleBeachRelaxation: "الاسترخاء",
  
  // Package 1
  package1Title: "الحزمة 1 - سريلانكا",
  package1Duration: "4 ليالٍ 5 أيام",
  package1Charges: "رسوم الفندق والنقل فقط",
  package1Hotel: "فندق 4 نجوم يشمل السرير والعشاء والإفطار",
  package1Price: "شخصين في اليوم 335 دولاراً",
  package1Day1: "اليوم 1",
  package1Day1Activity1: "بيناوالا",
  package1Day1Activity2: "كاندي (رقصة كاندي)",
  package1Day2: "اليوم 2",
  package1Day2Activity1: "ناليغالا",
  package1Day2Activity2: "معبد كاندي",
  package1Day3: "اليوم 3",
  package1Day3Activity1: "جادالادينيا، أمباكي",
  package1Day3Activity2: "حديقة بيرادينيا",
  package1Day4: "اليوم 4",
  package1Day4Activity1: "متحف الشمع كاندي",
  package1Day4Activity2: "تسوق الجواهر والتوابل والباتيك",
  package1Activities: "الأنشطة",
  
  // Package 2
  package2Title: "الحزمة 2 - سريلانكا",
  package2Duration: "4 ليالٍ 5 أيام",
  package2Charges: "رسوم الفندق والنقل فقط",
  package2Hotel: "فندق 4 نجوم يشمل السرير والعشاء والإفطار",
  package2Price: "شخصين في اليوم 335 دولاراً",
  package2Day1: "اليوم 1",
  package2Day1Activity1: "بيناوالا",
  package2Day1Activity2: "معبد كاندي",
  package2Day1Activity3: "رقصة كاندي",
  package2Day2: "اليوم 2",
  package2Day2Activity1: "تسوق الجواهر والتوابل والباتيك",
  package2Day2Activity2: "حديقة بيرادينيا",
  package2Day2Activity3: "ناليغالا",
  package2Day3: "اليوم 3",
  package2Day3Activity1: "نوارا إليا",
  package2Day3Activity2: "حديقة غريغوري",
  package2Day4: "اليوم 4",
  package2Day4Activity1: "مزرعة أمبوييلا",
  package2Activities: "الأنشطة",
  
  // Package 3
  package3Title: "الحزمة 3 - سريلانكا",
  package3Duration: "4 ليالٍ 5 أيام",
  package3Charges: "رسوم الفندق والنقل فقط",
  package3Hotel: "فندق 4 نجوم يشمل السرير والعشاء والإفطار",
  package3Price: "شخصين في اليوم 335 دولاراً",
  package3Day1: "اليوم 1",
  package3Day1Activity1: "بيناوالا",
  package3Day1Activity2: "معبد كاندي",
  package3Day1Activity3: "رقصة كاندي",
  package3Day2: "اليوم 2",
  package3Day2Activity1: "حديقة بيرادينيا",
  package3Day2Activity2: "ناليغالا",
  package3Day2Activity3: "تسوق الجواهر والتوابل والباتيك",
  package3Day3: "اليوم 3",
  package3Day3Activity1: "سيجيريا",
  package3Day4: "اليوم 4",
  package3Day4Activity1: "معبد دمبولا",
  package3Day4Activity2: "معبد قرية دمبولا",
  package3Activities: "الأنشطة",
  
  
  // Package tags
  hotel: "الفندق",
  transport: "النقل",
  cultural: "ثقافي",
  shopping: "التسوق",
  hillCountry: "البلد الجبلي",
  teaPlantations: "مزارع الشاي",
  sigiriya: "سيجيريا",
  heritageSites: "مواقع التراث",
  safari: "السفاري",
  wildlife: "الحياة البرية",
  
  // Package titles (short version for cards)
  package1: "الحزمة 1",
  package2: "الحزمة 2",
  package3: "الحزمة 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Two person per day $335",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Two person per day $335",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
